import { render, staticRenderFns } from "./LeftContent.vue?vue&type=template&id=10f22cb6&scoped=true"
import script from "./LeftContent.vue?vue&type=script&setup=true&lang=js"
export * from "./LeftContent.vue?vue&type=script&setup=true&lang=js"
import style0 from "./LeftContent.vue?vue&type=style&index=0&id=10f22cb6&prod&lang=less&scoped=true"
import style1 from "./LeftContent.vue?vue&type=style&index=1&id=10f22cb6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f22cb6",
  null
  
)

export default component.exports